DateService.$inject = [];

function DateService() {

    this.getSundayForDate = getSundayForDate;
    this.weekStartsAfter = weekStartsAfter;
    this.isSameDay = isSameDay;
    this.timeAsInteger = timeAsInteger;
    this.dateIsPast = dateIsPast;
    this.isDate = isDate;
    this.weekEntirelyInFuture = weekEntirelyInFuture;
    this.weekEntirelyInPast = weekEntirelyInPast;
    this.convertToJSPLCDate = convertToJSPLCDate;

    function weekEntirelyInFuture(weekDate) {
        weekDate = new Date(weekDate);
        let today = new Date();
        return weekStartsAfter(weekDate, today);
    }

    function weekEntirelyInPast(weekDate) {
        weekDate = new Date(weekDate);
        let today = new Date();
        return weekEndsOnOrBefore(weekDate, today);
    }

    function weekStartsAfter(weekDate, comparerDate) {
        weekDate = new Date(weekDate);
        comparerDate = new Date(comparerDate);
        let sunday = getSundayForDate(weekDate);

        return sunday > comparerDate;
    }

    function weekEndsOnOrBefore(weekDate, comparerDate) {
        weekDate = new Date(weekDate);
        comparerDate = new Date(comparerDate);
        let saturday = getSaturdayForDate(weekDate);

        return saturday <= comparerDate;
    }

    function getSundayForDate(date) {
        let dayInWeek = new Date(date);
        let dayOfWeek = dayInWeek.getDay();
        let dayOfMonth = dayInWeek.getDate();
        let diff = dayOfMonth - dayOfWeek;
        let sunday = new Date(dayInWeek.setDate(diff));

        return sunday;
    }

    function getSaturdayForDate(date) {
        let sunday = getSundayForDate(date);
        let saturday = sunday.setDate(sunday.getDate() + 6);
        return saturday;
    }

    function isSameDay(date1, date2) {
        let dateString1 = (new Date(date1)).toDateString();
        let dateString2 = (new Date(date2)).toDateString();
        return dateString1 === dateString2;
    }

    function timeAsInteger(dateTime) {
        let date = new Date(dateTime);
        let hours = date.getHours().toString();
        let minutes = '0' + date.getMinutes().toString();
        minutes = minutes.substring(minutes.length - 2);
        return parseInt(hours + minutes);
    }

    function dateIsPast(date) {
        date = new Date(date);
        return date < new Date().setHours(0, 0, 0, 0)
    }

    function isDate(date) {
        return date instanceof Date && !isNaN(date.valueOf());
    }

    function convertToJSPLCDate(date) {
        if (!date) return undefined;
        var milliSecondsInDay = 24 * 60 * 60 * 1000;
        // There are 129 days between 01011970 (Date(0)) and the theoretical 1970 P1W1.
        var between = new Date(date) - 129 * milliSecondsInDay;
        between /= milliSecondsInDay;
        var _days = Math.ceil(between) % 364; // Number of days into the financial year.

        return {
            year: ~~(between / 364) + 1970,
            period: ~~(_days / 28) + 1,
            week: ~~(_days % 28 / 7) + 1
        };
    }

}

export default DateService;



// WEBPACK FOOTER //
// ./src/js/services/dateservice/index.js